import { DataResponse } from "services/response";
import { BASE_API_URL } from "utils/constants";
import { downloadFileGet, downloadFilePost, downloadFilePostNew, get, post, put } from '../../utils/api';
import { getPlantCode } from 'utils/localStorageHelper';

// ================================== CUSTOMER SEGMENTS =================================
export interface CustomerSegmentModel {
  stt: number;
  id: string;
  customerSegmentCode: number;
  customerSegmentName: string;
  customerNumber: number;
  status: boolean;
  createBy: string;
  createTime: string;
  criterias: any[],
  description: string,
  actived: boolean

}

// ==================================== CUSTOMER CRM =============================================================
export type CustomerCRMModel = Partial<{
  stt: number;
  id: string;
  profileId: string,
  crmCode: number;
  customerName: string;
  phone: string;
  email: string;
  address: string;
  isCare?: boolean;
  isSpecialCare?: boolean;
  salesEmployeeInCharge: string,
  position: string,
  departmentName: string,

  actived: boolean,
  createTime: string,

  customerNameByContact: string,
  customerIdByContact: string,

  description: string,
  customerAdmin: string
  customerSales: string
  quantityShowroom: number
  gtdtb: number
  quantityEmployee: number
  tiLeLaiGop: number
  investmentValue: any
  area: string
  province: string
  district: string
  revenue: number

  doanhSoCtyMe: number,
  doanhSoGT: number,


  increaseRevenue: number
  productLevel: any
  interaction: any
  numberPurchase: number
  buyingGroupALot: any
  timeNotPurchased: number

  increaseRevenuePreviousPeriod: number,
}>

export type DetailContactSegment = {
  contactSegmentName: string,
  description: string,
  companyCode: string,
  listKH: CustomerCRMModel[],
  pagingSP?: {
    pageIndex: number,
    pageSize: number,
    totalCount: number,
    totalPages: number,
  }
}

// ==================================== ACTIVITIES OF CUSTOMER SEGMENT ===========================================
export interface ActivitiesOfCustomerSegment {
  stt: number
  crmCode: string
  title: string
  type: string
  status: string
  createTime: string
  customerCode: string
  customerName: string
  email: string
  contact: string
}

// ====================================== CHART ACTIVITIES =======================================================
export interface ChartActivitiesModel {
  monthCreate: string
  total: number
  activityDone: number
  activityUnfinished: number
}

// ===============================================================================================================
export type ListCustomerCriteria = Partial<{
  stt: number
  crmCode: string
  sapCode: string
  crM_SAPCode: string
  customerName: string
  address: string
  customerAdmin: string
  customerSales: string
  quantityShowroom: number
  gtdtb: number
  quantityEmployee: string
  tiLeLaiGop: number
  investmentValue: any
  area: string
  province: string
  district: string
  revenue: number
  increaseRevenue: number
  productLevel: any
  interaction: any
  numberPurchase: number
  buyingGroupALot: any
  timeNotPurchased: number
  increaseRevenuePreviousPeriod: number
  email: string
}>


export type commonLazySegment = {
  criteriaCode: string
  criteriaName: string
  inputType: string
  parentTitle: string
  values: [],
  value2s: string[]
}

export type ListLazySegmentResponse = {
  value: string,
  key: string,
  values: commonLazySegment[]
}


// ====================================== Khai báo phương thức ===================================================
export interface ICustomerSegmentServices {
  //   Lấy danh sách customer Segment
  getlistCustomerSegments(data: object): Promise<DataResponse<Array<CustomerSegmentModel>>>
  // Lấy danh sách khách hàng có trên CRM
  getListCustomerCRM(data: object): Promise<DataResponse<Array<CustomerCRMModel>>>
  // Lấy danh sách khách hàng ngoài
  getListCustomerOutside(data: object): Promise<DataResponse<Array<CustomerCRMModel>>>
  // Import khách hàng ngoài CRM
  importCustomerOutside(data: object): Promise<DataResponse<null>>
  // Download mẫu template excel khách hàng ngoài CRM
  downloadTemplateExceCustomerOutside(): Promise<void>
  // Tạo mới customer segment
  createCustomerSegment(data: object): Promise<DataResponse<null>>
  // cập nhật customer segmentation
  updateCustomerSegment(data: object): Promise<DataResponse<null>>

  // export customer segment
  exportReport(data: object): Promise<void>

  // count customer by criteria (Đếm khách hàng theo tiêu chí)
  countCustomerByCriteria(data: object): Promise<DataResponse<null>>

  // get list customer by criteria (danh sách khách hàng theo danh sách tiêu chí/ Paging)
  listCustomerByCriteria(data: object): Promise<DataResponse<ListCustomerCriteria[]>>

  // Danh sách khách hàng của Customer segment theo type
  getCustomerOfCustomerSegment(data: object): Promise<DataResponse<Array<CustomerCRMModel>>>
  // danh sách hoạt động của Customer segment theo type
  getActivitiesOfCustomerSegment(data: object): Promise<DataResponse<Array<ActivitiesOfCustomerSegment>>>
  // chart số lượng hoạt động cho segment theo tháng
  getDataChartActivities(id: string, year?: number): Promise<DataResponse<Array<ChartActivitiesModel>>>
  // Chart tăng trưởng khách hàng theo Customer segment
  getDataChartGrowthCustomerSegment(id: string, year?: number): Promise<DataResponse<Array<ChartActivitiesModel>>>
  // Chart doanh số Customer segment
  getDataChartRevenueCustomerSegment(id: string, year?: number): Promise<DataResponse<Array<ChartActivitiesModel>>>
  // lấy thông tin chi tiết segment
  getDetailCustomerSegment(id: string): Promise<DataResponse<CustomerSegmentModel | undefined>>


  // Lấy dropdown danh sách khách hàng của Phân khúc khách hàng chứa tiêu chí và value đã tạo, dùng LazyCreate phân khúc khách hàng
  getLazyCustomerSegment(keyWord?: string): Promise<DataResponse<Array<ListLazySegmentResponse>>>

  exportExcel(data: object): Promise<void>
}
// Hàm khởi tạo các phương thức của  service
export function createCustomerSegmentServices(): ICustomerSegmentServices {
  return {
    //   Lấy danh sách customer Segment
    getlistCustomerSegments: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Segmentation/list-customer-segmentation`, data))
        .data;
    },
    // Lấy danh sách khách hàng có trên CRM
    getListCustomerCRM: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Segmentation/list-customer-crm`, data))
        .data;
    },
    // Lấy danh sách khách hàng ngoài
    getListCustomerOutside: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Segmentation/list-customer-outside`, data))
        .data;
    },
    // Import khách hàng ngoài CRM
    importCustomerOutside: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Segmentation/import-customer-outside`, data))
        .data;
    },
    downloadTemplateExceCustomerOutside: async () => {
      await downloadFileGet(`Segmentation/download-tempdate-excel-khipn`);
    },
    // Tạo mới customer segment
    createCustomerSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/create-customer-segmentation', data)).data
    },
    // Cập nhật customer segment
    updateCustomerSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/edit-customer-segmentation', data)).data
    },

    exportReport: async (data) => {
      return (
        await downloadFilePost(
          `Segmentation/export-excel-cs`, data))
    },

    // count customer by criteria (Đếm khách hàng theo tiêu chí)
    countCustomerByCriteria: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/count-customer-by-criteria', data)).data
    },

    // get list customer by criteria (danh sách khách hàng theo danh sách tiêu chí/ Paging)
    listCustomerByCriteria: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/list-customer-by-criteria', data)).data
    },

    // Lấy danh sách khách hàng của customer segment theo type
    getCustomerOfCustomerSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/customer-of-customer-segment', data)).data
    },
    // danh sách hoạt động của Customer segment theo type
    getActivitiesOfCustomerSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/activities-of-customer-segment', data)).data
    },
    // chart số lượng hoạt động cho segment theo tháng
    getDataChartActivities: async (id, year) => {
      return (await get(BASE_API_URL, 'Segmentation/chart-activities-customersegment/' + id, { Year: year })).data
    },
    // Chart tăng trưởng khách hàng theo Customer segment
    getDataChartGrowthCustomerSegment: async (id, year) => {
      return (await get(BASE_API_URL, 'Segmentation/chart-growth-customersegment/' + id, { Year: year })).data
    },
    // Chart doanh số Customer segment
    getDataChartRevenueCustomerSegment: async (id, year) => {
      return (await get(BASE_API_URL, 'Segmentation/chart-revenue-customersegment/' + id, { Year: year, CompanyCode: getPlantCode() })).data
    },
    // lấy thông tin chi tiết segment
    getDetailCustomerSegment: async (id) => {
      return (await get(BASE_API_URL, `Segmentation/customer-segmentation/` + id)).data
    },

    // Lấy dropdown danh sách khách hàng của Phân khúc khách hàng chứa tiêu chí và value đã tạo, dùng LazyCreate  phân khúc khách hàng
    getLazyCustomerSegment: async (keyWord) => {
      return (await get(BASE_API_URL, `Segmentation/lazy-customer-segment/`, { keyWord: keyWord })).data
    },

    exportExcel: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Segmentation/export-excel-kh-bytc/`, data))
    }

  };
}
